<template>
  <div class="area-list">
    <div
      v-for="area in filteredAreas"
      :key="area.id"
      class="area-item"
      @mouseover="showAction = area.id"
      @mouseleave="showAction = null"
      @click="onAreaSelected(area)"
    >
      <div class="area-item-content">
        <div class="area-title">
          {{ area.name !== "" ? area.name : "No description provided" }}
        </div>

        <div class="area-subtitle">
          <v-icon
            small
            class="mr-1"
          >
            mdi-calendar
          </v-icon>

          <span class="area-subtitle-text">
            {{ area.creationDate }}
          </span>
        </div>
      </div>

      <div>
        <v-btn
          v-show="showAction === area.id"
          icon
          @mouseover="enableAction = true"
          @mouseleave="enableAction = false"
          @click.stop="onDeleteIconPressed(area)"
        >
          <v-icon :color="getDeleteIconColor">
            mdi-delete-outline
          </v-icon>
        </v-btn>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      max-width="300px"
      max-height="100"
    >
      <v-card class="px-4">
        <v-card-title class="mt-2">
          <v-row>
            <v-icon
              class="mr-1"
              color="blue"
            >
              mdi-trash-can
            </v-icon>
            Delete area
          </v-row>
        </v-card-title>

        <v-card-text style="height: 100px">
          <v-col class="mt-1 pa-0">
            <p>Are you sure you want to delete the area?</p>
          </v-col>

          <v-col class="mt-1 pa-0">
            <p>{{ selectedAreaText }}</p>
          </v-col>
        </v-card-text>

        <v-col>
          <v-row>
            <v-btn
              color="primary"
              rounded
              block
              class="mb-2"
              :disabled="!selectedArea"
              @click="onConfirmDeletePressed(selectedArea.id, selectedArea.theyrId)"
            >
              Delete
            </v-btn>
          </v-row>

          <v-row>
            <v-btn
              color="primary"
              class="mr-2"
              text
              rounded
              block
              @click="dialog = false"
            >
              Cancel
            </v-btn>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CustomAreas",

  data: () => ({
    showAction: null,
    enableAction: false,
    dialog: false,
    selectedArea: null,
  }),

  computed: {
    ...mapState("weatherRouting/customAreasModule", ["filteredAreas"]),
    ...mapState("weatherRouting/formModule", ["currentTab"]),

    getDeleteIconColor() {
      return this.enableAction ? "#E57373" : "#90A4AE";
    },

    selectedAreaText() {
      return this.selectedArea ? this.selectedArea.name : "";
    },
  },

  watch: {
    currentTab() {
      this.removeSelectedArea();
    },
  },

  methods: {
    onDeleteIconPressed(area) {
      this.selectedArea = area;
      this.dialog = true;
    },

    async onConfirmDeletePressed(areaId, theyrId) {
      await this.$store.dispatch(
        "weatherRouting/customAreasModule/deleteArea",
        {
          areaId,
          theyrId,
        }
      );

      this.dialog = false;
      this.selectedArea = null;
    },

    onAreaSelected(area) {
      this.$store.commit(
        "weatherRouting/customAreasModule/SET_SELECTED_AREA",
        area
      );
    },

    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/customAreasModule/filterAreasByDescription",
        {
          description: text,
        }
      );
    },

    removeSelectedArea() {
      this.$store.commit(
        "weatherRouting/customAreasModule/SET_SELECTED_AREA",
        null
      );
    },
  },
};
</script>

<style scoped>
.area-item {
  cursor: pointer;
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.area-item:hover {
  border: 1px solid var(--color-secondary);
}

.area-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
}

.area-subtitle {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
}

.area-subtitle .v-icon {
  color: var(--color-text) !important;
}

.area-subtitle-text {
  font-size: 12px;
  color: var(--color-text) !important;
}

.area-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 8px;
}

.area-item-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
